import type { App, Component } from "vue";

export default {
    install ( app: App ) {
        // importa tutti i .vue dentro /components/global
        const components = import.meta.glob( "../components/global/*.vue", { eager: true } );

        Object.entries( components ).forEach( ( [ path, definition ] ) => {
            const component = ( definition as { default: Component } ).default;

            // ricava il nome dal file, es. VIconifyBtn.vue → VIconifyBtn
            const componentName = path.split( "/" ).pop()?.replace( /\.\w+$/, "" );

            if ( componentName )
            {
                app.component( componentName, component );
            }
        } );
    },
};
